import { Component, HostBinding } from '@angular/core';
import { CmsBannerComponent } from '@spartacus/core';
import { BREAKPOINT, BreakpointService, CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { tap } from "rxjs/operators";

@Component({
  selector: 'cx-banner',
  templateUrl: './custom-banner.component.html',
  styleUrls: ['./custom-banner.component.scss'],
  standalone: false
})
export class CustomBannerComponent {
  @HostBinding('class') styleClasses: string;
  @HostBinding('style.background-color') backgroundColor?: string;

  data$: Observable<CmsBannerComponent> = this.component?.data$?.pipe(
    tap((data) => {
      this.styleClasses = data?.styleClasses;
      this.backgroundColor = data.backgroundSlide;
    }),
  );

  constructor(
    protected component: CmsComponentData<CmsBannerComponent>,
    protected breakpointService: BreakpointService,
  ) { }

  isMobile(): Observable<boolean> {
    return this.breakpointService?.isDown(BREAKPOINT.md);
  }

  getTarget(data: CmsBannerComponent): string | null {
    return data?.external === 'true' || data?.external === true ? '_blank' : null;
  }
}
